import { render, staticRenderFns } from "./DeprecatedResponseAnswer.vue?vue&type=template&id=5da1bf48"
import script from "./DeprecatedResponseAnswer.vue?vue&type=script&lang=ts"
export * from "./DeprecatedResponseAnswer.vue?vue&type=script&lang=ts"
import style0 from "./DeprecatedResponseAnswer.vue?vue&type=style&index=0&id=5da1bf48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports